<template>
  <section>
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding: 10px;">
      <el-form class="fr ac">
        <div style="width:300px">
          <el-input placeholder="请输入手机号码" v-model="search.mobile" />
        </div>

        <el-date-picker
          class="ml20"
          v-model="daterange"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        ></el-date-picker>

        <div class="ml40">
          <el-button @click="getContributeCorneaList" type="primary">查询</el-button>
        </div>
        <!--给按钮绑定事件-->

        <div class="ml40">
          <el-button @click="exportExcel" type="primary">导出</el-button>
        </div>
      </el-form>
    </el-col>

    <!--列表-->
    <el-table id="out-table" :data="contribute_cornea_list" highlight-current-row>
      <el-table-column prop="id" width="60" label="id"></el-table-column>

      <el-table-column prop="name" label="捐款人" sortable></el-table-column>
      <el-table-column prop="mobile" label="手机" sortable></el-table-column>

      <el-table-column prop="address" label="地址" sortable></el-table-column>

      <el-table-column prop="create_time" label="提交时间" sortable></el-table-column>
    </el-table>

    <div class="fr jc ac">
      <el-pagination
        :current-page.sync="page"
        :page-size.sync="page_size"
        :page-sizes="[10, 100, 500, 1000]"
        @current-change="getContributeCorneaList"
        @size-change="getContributeCorneaList"
        background
        layout="sizes,prev, pager, next"
        :total="total"
      ></el-pagination>
    </div>
  </section>
</template>

<script>
// 引入导出Excel表格依赖
import FileSaver from "file-saver";
import XLSX from "xlsx";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      daterange: [],
      page: 1,
      page_size: 10,
      total: 100,
      contribute_cornea_list: [],
      search: {
        mobile: ""
      }
    };
  },
  methods: {
    //获取列表
    getContributeCorneaList() {
      let param = {
        start_time: this.daterange[0],
        end_time: this.daterange[1] ? this.daterange[1] + " 23:59:59" : null,
        token: sessionStorage.getItem("token"),
        contribute_type: 3,
        page: this.page,
        page_size: this.page_size,
        mobile: this.search.mobile
      };

      // let loading =this.$loading();

      this.post("contribute/getList", param).then(res => {
        // loading.close();
        this.contribute_cornea_list = res.data;
        this.total = res.total;
        console.log(res);
      });
    },
    //定义导出Excel表格事件
    exportExcel() {
      /* 从表生成工作簿对象 */
      var wb = XLSX.utils.table_to_book(document.querySelector("#out-table"));
      /* 获取二进制字符串作为输出 */
      var wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array"
      });
      try {
        FileSaver.saveAs(
          //Blob 对象表示一个不可变、原始数据的类文件对象。
          //Blob 表示的不一定是JavaScript原生格式的数据。
          //File 接口基于Blob，继承了 blob 的功能并将其扩展使其支持用户系统上的文件。
          //返回一个新创建的 Blob 对象，其内容由参数中给定的数组串联组成。
          new Blob([wbout], { type: "application/octet-stream" }),
          //设置导出文件名称
          "sheet.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    }
  },
  mounted() {
    this.getContributeCorneaList();
  }
};
</script>

<style scoped>
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
</style>